"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputLoading = void 0;
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const InputLoading = (props) => (react_1.default.createElement("div", { className: "loader" },
    react_1.default.createElement("p", null,
        props.t('main:Loading'),
        "...")));
exports.InputLoading = InputLoading;
exports.default = (0, react_i18next_1.withTranslation)()(exports.InputLoading);
//# sourceMappingURL=InputLoading.js.map